const processGoogleTag = (event: any) => {
  if (!process.browser) {
    return;
  }
  if (window.dataLayer) {
    window.dataLayer.push(event);
  }
};
export default processGoogleTag;
